import { useQuery } from '@tanstack/react-query';
import { getDownloadTemplateHierarchy } from 'services/api/requests/uploads/uploads';

export const useDownloadTemplateHierarchy = () => {
	return useQuery(
		['download-template-hierarchy'],
		getDownloadTemplateHierarchy,
		{
			refetchOnWindowFocus: false,
			enabled: false,
		}
	);
};
